<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('cmsCareers') }}</h2>
				<ja-button
					v-if="showCreate || editCareerCluster"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table careers -->
			<ja-careers-table
				v-if="showCreate && careersData"
				:data="careersData"
				@observeRowCareer="handleObserveRowCareer"
				@editRow="handleEditRow"
				@editRowCareer="handleEditRowCareer"
				@editCareerCluster="handleEditCareerCluster"
				@deleteCareer="handleDeleteCareer"
			></ja-careers-table>
			<!-- Create new Template -->
			<ja-careers-create-new
				v-if="!showCreate && !editCareerCluster"
				:data-edit="dataEdit"
				:data-cluster-name="dataEditClusterName"
				:data-clusters-options="careersData"
				@saveCareer="handleSaveCareer"
				@deleteCareer="handleDeleteCareer"
				@cancel="handleCancel"
			></ja-careers-create-new>
			<!-- edit Career Cluster -->
			<ja-careers-cluster-edit
				v-if="!showCreate && editCareerCluster"
				:data="dataEdit"
				:is-observer="isTooObserve"
				@editRow="handleEditRow"
				@saveCareerCluster="handleEditCareerCluster"
				@cancel="handleCancel"
			></ja-careers-cluster-edit>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import CareersTable from './CareersTable.vue';
import CareerClusterEdit from './CareerClusterEdit.vue';
import CareerServices from '@/services/cms/CareerServices';
import CareersCreateNew from './CareersCreateNew';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaCareersTable: CareersTable,
		jaCareersClusterEdit: CareerClusterEdit,
		jaCareersCreateNew: CareersCreateNew,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreate: true,
			careersData: null,
			dataEdit: null,
			editCareerCluster: false,
			dataEditClusterName: null,
			jobTitleFormat: null,
			isTooObserve: false
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getCareerCluster();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		if (this.selectedFacility != null) {
			this.$store.commit('setLoading', true);
			this.getCareerCluster();
		}
	},
	methods: {
		async getCareerCluster() {
			const data = await CareerServices.getAllCareerClusters(
				this.selectedFacilityId
			);
			data.forEach(cluster => {
				cluster.cmsCareers.sort((a, b) => (a.name < b.name ? -1 : 1));
			});
			this.careersData = data.sort((a, b) => (a.name < b.name ? -1 : 1));
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await CareerServices.getCareerById();
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
			if (this.editCareerCluster === true) {
				this.editCareerCluster = false;
			}
		},
		async handleEditRow(rowData) {
			const data = await CareerServices.getCareerById(rowData.career_ID);
			this.dataEdit = data;
			this.dataEditClusterName = rowData.careerClusterName;
			this.showCreate = false;
			this.editCareerCluster = false;
			this.$store.commit('setIsReturnOption', false);
		},
		handleEditRowCareer(rowData) {
			this.showCreate = false;
			this.editCareerCluster = true;
			this.isTooObserve = false;
			this.dataEdit = rowData;
			this.$store.commit('setIsReturnOption', false);
		},
		handleObserveRowCareer(rowData) {
			this.isTooObserve = true;
			this.showCreate = false;
			this.editCareerCluster = true;
			this.dataEdit = rowData;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditCareerCluster(cluster) {
			this.$store.commit('setLoading', true);
			await CareerServices.updateCluster(cluster);
			await this.getCareerCluster();
			this.editCareerCluster = false;
			this.showCreate = true;
		},
		async handleSaveCareer(career) {
			this.$store.commit('setLoading', true);
			await CareerServices.update(career, this.selectedFacilityId);
			await this.getCareerCluster();
			this.editCareerCluster = false;
			this.showCreate = true;
		},
		async handleDeleteCareer(careerId) {
			this.$store.commit('setLoading', true);
			await CareerServices.deleteById(careerId);
			await this.getCareerCluster();
			this.showCreate = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getCareerCluster();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
